import { Eyebrow, Reveal } from "./motion";

const PHILO_IMG =
    "https://static.prod-images.emergentagent.com/jobs/042f1a63-d502-4eb1-8de6-71e5b27c4c81/images/1ea087249fcb07b7f643fe4c5517df1fc0ecd81d42bb794f02dd02a5c34f9527.jpeg";

const STATS = [
    { value: "100%", label: "Bespoke protocols" },
    { value: "1:1", label: "Gut & dietary care" },
    { value: "360°", label: "Inside-out approach" },
];

export default function Philosophy() {
    return (
        <section
            id="philosophy"
            data-testid="philosophy-section"
            className="bg-cream px-6 py-24 md:px-12 md:py-40"
        >
            <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-16 md:grid-cols-12">
                <div className="md:order-2 md:col-span-7">
                    <Eyebrow index="01">The philosophy</Eyebrow>

                    <Reveal delay={0.1}>
                        <h2 className="mt-8 font-serif text-[clamp(2.2rem,4.5vw,4.25rem)] font-light leading-[1.05] text-ink">
                            The gut speaks.
                            <br />
                            <span className="italic text-earth">The skin listens.</span>
                        </h2>
                    </Reveal>

                    <Reveal delay={0.2}>
                        <p className="mt-10 max-w-xl text-base font-light leading-relaxed text-earth md:text-lg">
                            We align the gut with the skin — pairing bespoke
                            cosmeceutical treatments with targeted dietary advice,
                            gut-friendly supplements and daily wellness rituals.
                        </p>
                    </Reveal>

                    <Reveal delay={0.3}>
                        <p className="mt-10 max-w-xl font-serif text-2xl font-light italic leading-snug text-ink md:text-[2rem]">
                            “True skin transformation requires care from the inside
                            out.”
                        </p>
                    </Reveal>

                    <Reveal delay={0.4}>
                        <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-earth md:text-lg">
                            Our holistic approach treats your skin both internally
                            and externally — one considered protocol, made only
                            for you.
                        </p>
                    </Reveal>

                    <Reveal delay={0.5}>
                        <div className="mt-14 grid grid-cols-3 gap-6 border-t border-ink/10 pt-10">
                            {STATS.map((s) => (
                                <div key={s.label}>
                                    <div className="font-serif text-3xl font-light text-ink md:text-5xl">
                                        {s.value}
                                    </div>
                                    <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-clay">
                                        {s.label}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Reveal>
                </div>

                <div className="md:order-1 md:col-span-5">
                    <Reveal delay={0.25} className="relative md:sticky md:top-28">
                        <div className="absolute -inset-3 rounded-[32px] border border-clay/30" aria-hidden="true" />
                        <div className="relative overflow-hidden rounded-[28px]">
                            <img
                                src={PHILO_IMG}
                                alt="Natural, healthy skin — the result of inside-out care"
                                loading="lazy"
                                className="aspect-[4/5] w-full object-cover transition-transform duration-[1.2s] ease-out hover:scale-[1.04]"
                            />
                        </div>
                        <p className="mt-6 text-right font-mono text-[10px] uppercase tracking-[0.25em] text-clay">
                            Skin, considered
                        </p>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
